<template>
  <va-create-layout :title="title">
    <va-form :id="id" v-model="form" :item="item">
      <v-row justify="center">
        <v-col sm="12">
          <v-card>
            <v-card-text>
              <va-text-input required source="name"></va-text-input>
              <va-text-input required source="email"></va-text-input>
              <!-- todo: edit functionality working, but va-password-input field not showing exist password  -->
              <va-password-input v-model="form.password" required source="password"></va-password-input>
              <v-autocomplete
                v-model="form.timezone"
                source="timezone"
                label="Timezone"
                filled
                :items="timezonesData"></v-autocomplete>
              <va-select-input
                v-model="form.organizations"
                required
                filled
                source="organizations"
                reference="organizations"
                item-value="@id"
                multiple>
              </va-select-input>
              <va-select-input
                v-model="form.domains"
                filled
                required
                source="domains"
                reference="domains"
                item-value="@id"
                multiple>
              </va-select-input>

              <va-save-button></va-save-button>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </va-form>
  </va-create-layout>
</template>

<script>
  import { formattedTimezonesData } from "@/utility/getAllTimezones";

  export default {
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        timezonesData: formattedTimezonesData,
        form: {
          timezone: "",
          domains: [],
        },
      };
    },
    beforeMount() {
      if (this.item) {
        this.form.timezone = this.item.timezone;
        this.form.organizations = this.item.organizations;
        this.form.domains = this.item.domains;
        this.form.password = this.item.password;
      }
    },
  };
</script>
